const LINE_COLOR = 'rgba(0,0,0,0.2)';
const MIN_ZOOM = 0.1;
const MAX_ZOOM = 4;
const DEFAULT_ZOOM = 0.7;
const ZOOM_PERCENT_STEP = 10;
export const DEFAULT_GRID_SIZE = 25;
export const MIN_RECT_SIZE = 50;
export const DEFAULT_STROKE_WIDTH = 0;
export const DEFAULT_TEXT_STYLE = 'sans-serif';
export const DEFAULT_RECT_HEIGHT = MIN_RECT_SIZE * 3;
export const DEFAULT_RECT_WIDTH = MIN_RECT_SIZE * 8;
export const DEFAULT_COVERAGE_HEIGHT = 50;
export const DEFAULT_RETENTION_HEIGHT = 25;

function drawGrid(
  context: CanvasRenderingContext2D,
  scrollX: number,
  scrollY: number,
  zoom: number,
  canvasWidth: number, // width must be normalized with devicePixelRatio
  canvasHeight: number // height must be normalized with devicePixelRatio
) {

  const width = Math.max(canvasWidth, canvasWidth / window.devicePixelRatio);
  const height = Math.max(canvasHeight, canvasHeight / window.devicePixelRatio);
  const scaledGridSize = DEFAULT_GRID_SIZE * zoom;
  const offsetX = -scaledGridSize + (scrollX % scaledGridSize);
  const offsetY = -scaledGridSize + (scrollY % scaledGridSize);
  const lineWidth = Math.min(1 / zoom, 1);

  context.save();
  context.lineWidth = lineWidth;

  for (let x = offsetX; x < offsetX + width + scaledGridSize * 2; x += scaledGridSize) {
    context.beginPath();
    context.strokeStyle = LINE_COLOR;
    context.moveTo(x, offsetY - scaledGridSize);
    context.lineTo(x, offsetY + height + scaledGridSize * 2);
    context.stroke();
  }

  for (let y = offsetY; y < offsetY + height + scaledGridSize * 2; y += scaledGridSize) {
    context.beginPath();
    context.strokeStyle = LINE_COLOR;
    context.moveTo(offsetX - scaledGridSize, y);
    context.lineTo(offsetX + width + scaledGridSize * 2, y);
    context.stroke();
  }
  context.restore();
}

export default { drawGrid, MAX_ZOOM, MIN_ZOOM, DEFAULT_ZOOM, ZOOM_PERCENT_STEP };
